<template>
  <div class="tbp">
    <div class="order-list" v-if="invoiceTitleList.length != 0">
      <div class="order-item" v-for="(item,index) in invoiceTitleList" :key="item.id" :class="index === invoiceTitleList.length - 1 ? 'no-border':'border-devider'">
        <div class="select-btn" v-if="selectFlag">
          <input type="radio"
          name="company"
          class="check_box tui-checkbox"
          @change="itemChange(index)"/>
        </div>
        <div class="detail-item">
          <div class="info">
            <div class="row company">
              <span>{{item.companyName}}</span>
              <!-- <span v-if="item.isDefault == 1" class="default">默认</span> -->
               <div style="margin-right:10px">
                <span v-if="item.isDefault == 1" class="default">默认</span>
                <span class="update" @click="toUpdateInvoiceTitle(item.id)" v-if="!selectFlag">修改</span>
                <span class="delete" @click="toDeleteInvoiceTitle(item.id)" v-if="!selectFlag">删除</span>
              </div>
            </div>
            <div class="row number" v-if="item.taxId != ''">
                <span>税号</span>
                <span>{{item.taxId}}</span>
            </div>
          </div>
          <!-- <div class="icon-arrow">
            <img src="~@/assets/image/invoiceTitle/list/arrow.png" alt="">
          </div> -->
        </div>
      </div>
    </div>
    <emptyContent text="暂无发票抬头" v-else />
    <div class="bottom">
      <div class="continue" v-if="selectFlag" @click="hanleToMakeInvoice">确定</div>
      <div class="continue" v-else @click="addInvoiceTitile">添加</div>
    </div>
    <selectpopup v-if="popupstate" @onselectpopup="onselectpopup" title="删除订单" content="是否确定要删除 ？"/>
  </div>
</template>

<script>
import { getInvoiceTitleList,deleteInvoiceTitle } from '@/service/invoiceTitle/api.js';
export default {
  name: 'invoiceTitleList',
  data() {
    return {
      invoiceTitleList: [],
      selectFlag: false ,
      selectedRow:{},
      popupstate: false,
      deleteId:"",
      isAlign:false,
    }
  },
  created () {
    this.selectFlag = this.$route.query.isSelect
    // console.log(this.$route.query.isAlign)
    //  console.log(typeof(this.isAlign))
    if(this.$route.query.isAlign) {
       this.isAlign = this.$route.query.isAlign
      // console.log(typeof(this.isAlign))
    }
    this.getList()
  },
  methods: {
    async getList() {
      const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      const parameter = {
          userId: userInfo.userId
      };
      const { data } = await getInvoiceTitleList.call(this, parameter);
      this.invoiceTitleList = data
      // const baseInfo = JSON.parse(window.sessionStorage.getItem('baseInfo'));
      // if(baseInfo !== null){
      //   this.invoiceTitleList = data.filter((item)=>{
      //     // return item.taxId !== ""
      //     return item.type == 'company'
      //   })
      // }else{
      //   this.invoiceTitleList = data
      // }
    },
    itemChange(index) {
      this.selectedRow = this.invoiceTitleList[index]
    },
    addInvoiceTitile() {
      this.$router.push(`/invoiceTitleAdd`);
    },
    toUpdateInvoiceTitle (id,item) {
      this.$router.push({path:'/invoiceTitleAdd',query: { id,item }});
    },
    toDeleteInvoiceTitle(id) {
      this.deleteId = id
      this.popupstate = true
    },
    async onselectpopup(state){
      if(state === 'determine'){
        const parameter = {
          invoiceId:this.deleteId
        }
        const res = await deleteInvoiceTitle.call(this, parameter);
        if(res.errorMessage == "") {
          this.deleteId = ""
          this.$toast('删除成功');
          this.getList();
        }

      }
      this.$store.commit('setWindowMaskEl', null)
      this.popupstate = false;
    },
    hanleToMakeInvoice () {
      const oldTitle = JSON.parse(window.sessionStorage.getItem('selectedInvoiceTitle'))
      if(oldTitle != null) {
        if(this.selectedRow.hasOwnProperty('id')) {
          delete this.selectedRow.id
        }
        Object.assign(oldTitle,this.selectedRow)
        window.sessionStorage.setItem('selectedInvoiceTitle', JSON.stringify(oldTitle));
      }else{
        window.sessionStorage.setItem('selectedInvoiceTitle', JSON.stringify(this.selectedRow));
      }
      // console.log(this.isAlign)
      if(this.isAlign == 'true') {
        this.$router.push(`/alignWirteInvoice`);
      }else{
        this.$router.push(`/wirteInvoiceName`);
      }
    }
  }

}
</script>

<style scoped lang='less'>
.tbp {
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}

.order-list {
  background: #FFFFFF;
  padding: .4rem;
  margin: (.533333rem / 2);
  border-radius: .266667rem;
  .order-item{
    padding: .133333rem 0;
    display: flex;
    align-items: center;
    .select-btn{
      width: .933333rem;
    }
    .detail-item{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .info{
        width: 5.333333rem;
        font-size: .32rem;
        color: #333;
        width: 100%;
        .row{
          margin-top: .32rem;
          margin-bottom: .32rem;
          display: flex;
          align-items: center;
          // white-space: nowrap;
        }
        .company{
          font-size: .3rem;
          color: #333;
          width: 100%;
          span:first-child{
            width: 4rem
          }
        }
        .number{
          font-size: .32rem;
          color: #999999;
          span{
            padding: 0 .133333rem 0 0;
          }
        }
      }
      .icon-arrow{
        img{
          width: .173333rem;
        }
      }
    }
  }
  .border-devider{
    border-bottom: 1px solid rgba(151, 151, 151, .24);
  }
}

.default{
  padding: .053333rem .266667rem !important;
  color: #3B6D9C;
  background: #F1F5F8;
  margin-left: .266667rem;
}

.update{
  padding: .053333rem .266667rem !important;
  color: #3B6D9C;
  border: 1px solid #3B6D9C;
  margin-left: .266667rem;
}

.delete{
  padding: .053333rem .266667rem !important;
  color: #DB4239;
  border: 1px solid #DB4239;
  margin-left: .266667rem;
}

.bottom{
  height: 1.6rem + .346667rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgb(248, 248, 248);
  .continue{
    position: fixed;
    margin: auto;
    width: 98%;
    bottom: .266667rem;
    left: 0;
    right: 0;
    background: #3B6D9C;
    line-height: 1.2rem;
    border-radius: 1.333333rem;
    text-align: center;
    color: #FFFFFF;
    font-size: .48rem;
  }
}
.tui-checkbox {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  font-size: 0.8rem;
  margin: 0;
  padding: 0;
  position: relative;
  display: inline-block;
  vertical-align: top;
  cursor: default;
  -webkit-appearance: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-transition: background-color ease 0.6s;
  transition: background-color ease 0.6s;
}
.tui-checkbox:checked {
  background: #DB4239;
  border: solid 1px #DB4239;
}
.tui-checkbox:checked::after {
  content: '';
  top: 0.1rem;
  left: 0.09rem;
  position: absolute;
  background: transparent;
  border: #fff solid 2px;
  border-top: none;
  border-right: none;
  height: 0.12rem;
  width: 0.25rem;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
</style>
